import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-temp-universal-add',
  templateUrl: './temp-universal-add.component.html',
  styleUrls: ['./temp-universal-add.component.scss']
})
export class TempUniversalAddComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
